import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DateFnsFormat, LifecycleAware } from '@lsq-frontend/common-ui';
import { Icons, ResponsiveService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import {
    GetCollectionChecksResponse,
    GetCollectionChecksRequest,
    GetTopNCollectionChecksService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import moment from 'moment';
@LifecycleAware()
@Component({
    selector: 'collections',
    templateUrl: './collections.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./collections.component.scss']
})
export class CollectionsComponent implements OnInit {
    public readonly icons = Icons;
    public readonly noDataTitle = this._i18n('No collections to show yet.');
    public collectionLink = '/reports/collections?date=';
    public dataSource: LsqApiServiceListSource<
        GetCollectionChecksResponse,
        GetCollectionChecksRequest
    >;
    public isSmBelow$ = this._responsiveService.smBelow;

    public paymentDateHeader = this._i18n({
        value: 'Date',
        meaning: 'Table column header'
    });

    public debtorNameHeader = this._i18n({
        value: 'Customer',
        meaning: 'Table column header'
    });

    public checkNumberHeader = this._i18n({
        value: 'Reference Number',
        meaning: 'Table column header'
    });

    public checkInvoiceAmountHeader = this._i18n({
        value: 'Invoice Amount',
        meaning: 'Table column header'
    });

    public checkPaymentAmountHeader = this._i18n({
        value: 'Payment Amount',
        meaning: 'Table column header'
    });

    constructor(
        private _i18n: I18n,
        @Inject(GetTopNCollectionChecksService)
        private _colletionService: GetTopNCollectionChecksService,
        public _responsiveService: ResponsiveService
    ) {}

    public ngOnInit(): void {
        const getColletionChecksRequest = new GetCollectionChecksRequest({
            take: 5
        });

        this.dataSource = new LsqApiServiceListSource(
            this._colletionService,
            getColletionChecksRequest
        );
    }

    private _getDateFormat(date: string): string {
        return moment(date).format(DateFnsFormat.ShortFormat);
    }

    public getCollectionURL(date: string): string {
        return this.collectionLink + this._getDateFormat(date);
    }

    public getCustomerCollections(row): string {
        return `customers/${row.debtorKey}/report/collections?date=${this._getDateFormat(
            row.paymentDate
        )}`;
    }
}
